<template>
  <div class="pt-2 mt-2 border card shadow" style="border-radius: 20px">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center w-full mb-2">
        <div>
          <div class="text-dark" style="font-weight: 500; font-size: 18px; line-height: 24px;">{{ title }}</div>
        </div>
      </div>

      <vue-apex-charts
        type="pie"
        height="300"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>
  
<script>
  import VueApexCharts from 'vue-apexcharts'

  export default {
    name: "ReportPieChart",
    components: {
      VueApexCharts,
    },
    
    props: {
      series: {
        type: Array,
        default: () => [],
      },
      chartOptions: {
        type: Object,
        default: null,
      },
      title: {
        default: "",
        type: String,
        required: false,
      }
   
    },
  }
</script>

